$(window).on("load", function(){

    return;

    //The map is being pulled from the frontend

    if (typeof initializeMap === "function"){

        $.post(site_url + "ajax/functions.php", {
            operation: 'loadMapPins',
            map_image_size: (typeof map__image_size === undefined ? map__image_size : "thumbnail"),
        }, function(data) {

            initializeMap(data.config.map_latitude, data.config.map_longitude, data.config.map_zoom);

            //Set Hotel Pin
            const hotel_marker = {
                id: 0,
                // name: data.hotel.name,
                name: "",
                description: data.hotel.description,
                thumb: "",
                lat: data.hotel.lat,
                long: data.hotel.long,
                url: "",
                icon: data.hotel.icon
            };

            loadMarker(hotel_marker,'');

            const pins = data.pins;
            const number_of_pins = Object.keys(pins);

            for (let index = 1; index < number_of_pins.length; ++index) {
                let pin =  pins[index];
                loadMarker(pin, "");
            }

        }, "json");

    }

});